import { motion } from "framer-motion";

export const FloatingGhost = ({ className = "", delay = 0, size = 56, opacity = 0.9 }) => (
  <motion.div
    className={`pointer-events-none absolute ${className}`}
    animate={{ y: [-10, 10, -10], rotate: [-3, 3, -3] }}
    transition={{ repeat: Infinity, duration: 4.5, delay, ease: "easeInOut" }}
    aria-hidden="true"
    style={{ opacity }}
  >
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
      <path
        d="M32 6C20 6 11 15 11 27v27l7-5.5L25 54l7-5.5L39 54l7-5.5L53 54V27C53 15 44 6 32 6Z"
        fill="#F3F4F6"
        fillOpacity="0.92"
      />
      <circle cx="24" cy="28" r="4" fill="#0A0812" />
      <circle cx="40" cy="28" r="4" fill="#0A0812" />
      <ellipse cx="32" cy="40" rx="4.5" ry="6" fill="#0A0812" />
    </svg>
  </motion.div>
);
